var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarrotDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-down-sign-to-navigate_1",
    "data-name": "arrow-down-sign-to-navigate 1",
    transform: "translate(0 -0.458)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "arrow-down-sign-to-navigate_1-2",
    "data-name": "arrow-down-sign-to-navigate 1",
    width: 16,
    height: 16,
    transform: "translate(0 0.458)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.359 3.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.9,5.582a.684.684,0,0,1-.485-.2L.2,1.171A.686.686,0,0,1,1.171.2L4.9,3.927,8.622.2a.686.686,0,0,1,.97.97L5.381,5.382a.684.684,0,0,1-.485.2Z",
    transform: "translate(2.744 2.013)",
    fill: "#333"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrotDown);
export default __webpack_public_path__ + "static/media/carrot-down.96110921.svg";
export { ForwardRef as ReactComponent };